import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { DropCountdown } from "@/components/DropCountdown";

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("ALL");

  useEffect(() => {
    api.products().then(setProducts).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const tags = ["ALL", ...new Set(products.map((p) => p.seasonal_tag).filter(Boolean))];
  const visible = filter === "ALL" ? products : products.filter((p) => p.seasonal_tag === filter);

  return (
    <div className="max-w-6xl mx-auto px-5 pt-14 relative" data-testid="shop-page">
      <img
        src="/assets/runrs-world.png"
        alt="RUNRS world graphic — letterman mascot leaning on an R in front of a globe"
        data-testid="shop-world-graphic"
        className="absolute top-4 right-4 w-28 sm:w-44 lg:w-60 pointer-events-none select-none"
      />
      <p className="font-college text-lg text-red">SHIPPED WORLDWIDE</p>
      <h1 className="font-college text-4xl sm:text-5xl text-navy mt-2" data-testid="shop-heading">SHOP</h1>
      <p className="font-college text-xl md:text-2xl text-ink mt-3 max-w-[60%] sm:max-w-md" data-testid="shop-subtitle">
        CORE STAPLES + SEASONAL DROPS
      </p>
      <DropCountdown />

      <div className="flex flex-wrap gap-2 mt-8 mb-10" data-testid="shop-filters">
        {tags.map((f) => (
          <button
            key={f}
            data-testid={`filter-${f.toLowerCase()}`}
            onClick={() => setFilter(f)}
            className={`font-college text-base px-3 py-1.5 transition-colors ${
              filter === f ? "bg-ink text-paper" : "bg-paper hover:bg-yellow"
            }`}
          >
            {f}
          </button>
        ))}
      </div>

      {loading ? (
        <p className="text-ink/50 py-20" data-testid="shop-loading">Loading the pieces…</p>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 md:gap-8 pb-10" data-testid="shop-grid">
          {visible.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      )}
    </div>
  );
}
